import $ from 'jquery'
const $parents = $('.header-menu .menu-item-has-children')
const parents = document.querySelectorAll('.header-menu .menu-item-has-children')
const headerMenuHandler = ()=> {
    
  
  //console.log(arow)

  parents.forEach( item => {
    const arowWrapper = document.createElement('span')
    arowWrapper.innerText = ''
    arowWrapper.classList.add('menu-item__arow-wrapper')

    const arow = document.createElement('span')
    arow.innerText = '>'
    arow.classList.add('menu-item__arow')

    arowWrapper.insertAdjacentElement('afterbegin', arow)

    const element = item.querySelector('a')
    element.insertAdjacentElement('beforeend', arowWrapper)
  })

  const btns = document.querySelectorAll('.menu-item__arow')

  if(!btns)
    return

  btns.forEach( btn => {
    btn.addEventListener('click', e => {
      e.preventDefault()
      const subMenu = $(btn).parents('.menu-item-has-children').find('.sub-menu')
      $(btn).toggleClass('menu-item__arow--active')
      console.log(btn)
      $(subMenu).slideToggle()
    })
  })

    // $.each( $parents, ( index, item ) => {

    //   const element = item.querySelector('a')
    //   element.style.color = 'red'
    //   element.insertAdjacentElement('beforeend', arow)
    //   console.log(element)
      
    //     // item.addEventListener('click', e => {
    //     //   if(e.target.parentElement.classList.contains('menu-item-has-children')) {
    //     //     e.preventDefault()
    //     //     const child = $(item).find('.sub-menu')
    //     //     $(item).toggleClass('menu-item-has-children--open')
    //     //     $(child).slideToggle()
    //     //   }       
    //     // })
    // })

}



export default headerMenuHandler